export default __webpack_public_path__ + "static/us-consumer-reviews-another_reason-98a4707a9c53b4e8cb95a0b63469b748.jpeg";